export default __webpack_public_path__ + "static/media/P200-Plunger.dbc0768e.svg";